module.exports = __webpack_public_path__ + "media/files/privacy_policy-8451bef1df01b400a51c687932a722a5.docx";